import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "smilingFace"
const SmilingFaceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.8 11.678a8.182 8.182 0 1 1-16.364 0 8.182 8.182 0 0 1 16.363 0m1.818 0c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10m-14.546-.455a.91.91 0 1 1 1.818 0h1.819a2.727 2.727 0 1 0-5.455 0zm4.546 4.546a4.6 4.6 0 0 1-4.174-2.652l-1.653.758a6.42 6.42 0 0 0 5.827 3.712 6.42 6.42 0 0 0 5.826-3.712l-1.653-.758a4.6 4.6 0 0 1-4.173 2.652m3.636-5.455a.91.91 0 0 0-.909.91h-1.818a2.727 2.727 0 0 1 5.454 0h-1.818a.91.91 0 0 0-.909-.91"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SmilingFaceIcon
